import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { AuthService } from 'src/app/admihair/service/auth.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { CriptografiaUtil } from 'src/app/admihair/util/criptografia-util';
import { LayoutService } from 'src/app/layout/service/app.layout.service';

@Component({
	templateUrl: './login.component.html'
})
export class LoginComponent {

	rememberMe: boolean = false;

	form: any = {
		email: null,
		password: null
	};
	isLoggedIn = false;
	isLoginFailed = false;
	errorMessage = '';
	loading: boolean = false;

	constructor(private layoutService: LayoutService,
		private authService: AuthService,
		private utilStorageService: UtilStorageService,
		private _router: Router,
		private _activatedRoute: ActivatedRoute) { }

	messages: Message[] = [];
	messagemVisivel: boolean = false;

	get dark(): boolean {
		return this.layoutService.config.colorScheme !== 'dark';
	}

	ngOnInit(): void {
		if (this.utilStorageService.getToken()) {
			this.isLoggedIn = true;
		}
	}

	fazerLogin(): void {
		this.loading = true;
		const { login, password } = this.form;

		this.authService.login(login, password).subscribe(
			data => {
				CriptografiaUtil.generateSecretKey(data.usuario.id);
				this.loading = false;
				if (data.usuario.situacaoConfirmacaoConta === 'CONFIRMADO') {
					this.utilStorageService.saveToken(data.token);
					this.utilStorageService.saveRefreshToken(data.refreshToken);
					this.utilStorageService.saveUser(data);
					this.isLoginFailed = false;
					this.isLoggedIn = true;

					if (!data.usuario.primeiroAcesso) {
						const acesso = this.utilStorageService.getUser();
						if (acesso.usuario.tipo === 'EMPRESA') {
							this.redirecionarSelecionarEmpresa();
						} else if (acesso.usuario.tipo === 'FRANQUIA') {
							this.redirecionarFranquia();
						} else {
							this.redirecionarAcessoNegado();
						}
					} else {
						this._router.navigate(["/primeiro-acesso/" + data.usuario.id],
						 { relativeTo: this._activatedRoute });
					}

				} else if (data.usuario.situacaoConfirmacaoConta === 'AGUARDANDO_CONFIRMACAO') {
					this.messages = [{
						severity: 'warn',
						summary: 'Atenção',
						detail: 'Acesse o seu e-mail e confirme o seu cadastro'
					}];
					this.messagemVisivel = true;
				} else {
					this.messages = [{
						severity: 'warn',
						summary: 'Atenção',
						detail: 'Confirmação rejeitada'
					}];
					this.messagemVisivel = true;
				}




			},
			err => {
				console.log(err)
				this.loading = false;
				if(err.status = HttpStatusCode.BadRequest){
					this.messages = [{
						severity: 'error',
						summary: 'Erro',
						detail: 'Usuário ou senha inválido'
					}]
					this.messagemVisivel = true;
				} else {
					this.messages = [{
						severity: 'error',
						summary: 'Erro',
						detail: 'Ocorreu um tentar realizar o login'
					}]
					this.messagemVisivel = true;
				}
				

			}
		);
	}

	reloadPage(): void {
		window.location.reload();
	}

	redirecionarResetSenha(){
		this._router.navigate(["/auth/recuperar-senha"], { relativeTo: this._activatedRoute });
	}

	redirecionarSelecionarEmpresa() {
		this._router.navigate(["/selecionar-empresa"], { relativeTo: this._activatedRoute });
	}

	redirecionarFranquia() {
		this._router.navigate(["/selecionar-franquia"], { relativeTo: this._activatedRoute });
	}

	redirecionarAcessoNegado() {
		this._router.navigate(["/auth/access"], { relativeTo: this._activatedRoute });
	}

}
